export const INITIAL_STATE = {
  assessmentsSummary: {},
  //
  getAssessmentsSummaryLoading: false,
  getAssessmentsSummarySuccess: null,
  getAssessmentsSummaryFailure: null,
}
